import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface OptionCardProps {
  icon: ReactNode;
  label: string;
  sublabel?: string;
  selected: boolean;
  onClick: () => void;
  testId?: string;
}

export function OptionCard({
  icon,
  label,
  sublabel,
  selected,
  onClick,
  testId,
}: OptionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "w-full p-6 rounded-xl border-2 transition-all text-left",
        "hover:shadow-md hover:border-teal-300 dark:hover:border-teal-600",
        selected
          ? "border-teal-700 bg-teal-50 dark:bg-teal-950/30"
          : "border-border bg-card"
      )}
      data-testid={testId}
    >
      <div className="flex items-start gap-4">
        <div
          className={cn(
            "w-12 h-12 rounded-lg flex items-center justify-center shrink-0",
            selected
              ? "bg-teal-700 text-white"
              : "bg-muted text-muted-foreground"
          )}
        >
          {icon}
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold mb-1">{label}</h3>
          {sublabel && (
            <p className="text-sm text-muted-foreground">{sublabel}</p>
          )}
        </div>
      </div>
    </button>
  );
}
